module.exports = __webpack_public_path__ + "static/media/tests-disabled.71cd127a.svg";